import { makeStorageProvider } from 'shared/infra/providers';

import getReferrerHostname from './getReferrerHostname';

/**
 * Origem externa da visita, guardada para continuar disponível depois que a
 * navegação interna apaga o `document.referrer` original.
 *
 * Toda entrada externa nova sobrescreve a anterior — mesma regra de última
 * interação que os cookies de UTM já seguem (ED-6914). Antes o primeiro valor
 * resolvido valia para sempre, e como a ausência de referrer também era
 * gravada, quem acessasse o site direto uma única vez nunca mais teria origem
 * atribuída em visita nenhuma (ED-7201).
 */
export default function getSessionReferrer() {
  const storageProvider = makeStorageProvider();
  const currentReferrer = getReferrerHostname(document.referrer);

  if (currentReferrer) {
    storageProvider.store('REFERRER', currentReferrer);

    return currentReferrer;
  }

  const storedReferrer = storageProvider.get('REFERRER');

  if (typeof storedReferrer !== 'string') return undefined;

  return storedReferrer || undefined;
}
